import {
  SET_PRIVATE_INFO,
  STASH_PRIVATE_INFO_CHANGES,
  SET_SAVING_PRIVATE_INFO_STATUS,
  CLEAR_PRIVATE_INFO,
  SET_LOADING,
} from './mutationTypes';
import initialState from './initialState';

export default {
  [SET_PRIVATE_INFO](store, data) {
    store.data = data;
  },
  [STASH_PRIVATE_INFO_CHANGES](store, updates) {
    store.data = { ...store.data, ...updates };
  },
  [SET_SAVING_PRIVATE_INFO_STATUS](store, value) {
    store.saving = value;
  },
  [CLEAR_PRIVATE_INFO](store) {
    Object.assign(store, initialState);
  },
  [SET_LOADING](store, value) {
    store.loading = value;
  },
};
